/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import WebEvent from './webevent'
import MobEvent from './mobevent'
import * as actions from "../../actions";
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
class GameBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: document.documentElement.clientWidth,
        };
    }
    render() {
        let game = null
        if (window.location.href === "/home") {
            game = this.props.homeData
        } else {
            game = this.props.game
        }
        game = game.filter((evet, i) => {
            return evet.eventTypeId === this.props.gameCode && (this.props.gameCode === '300' ? evet.markets.filter((itm) => itm.marketType === "DAILY").length > 0 : true)
        })
        let curGameLength = game.filter((evet, i) => {
            return evet.eventTypeId === this.props.gameCode && (this.props.gameCode === '300' ? evet.markets.filter((itm) => itm.marketType === "DAILY").length > 0 : true)
        }).length
        let limit = this.props.limit
        let count = 0
        return (
            <div className="cricket mt-7">
                <div className="sub_path center-box">
                    <p>{this.props.gameCode === "4" ? "Cricket" : this.props.gameCode === "1" ? "Soccer" : this.props.gameCode === "2" ? "Tennis" : this.props.gameCode === "400" ? "Kabaddi" : this.props.gameCode === "500" ? "Election" : this.props.gameCode === "300" ? "Binary" : "Horse Racing"}</p>
                </div>
                {/* Desktop View */}
                {this.state.width > 767 && <div className="game-wrap col3 desktop-view">
                    <table className="table w-100 game-list-col">
                        <tbody>
                            {curGameLength > 0 ? <tr>
                                <td className="eventInfo"></td>
                                {this.props.gameCode === '300' ?
                                    <>
                                        <td className="col-visit"></td>
                                        <td className="col-draw"><span className="d-inline-block"><b>No</b></span></td>
                                        <td className="col-home"><span className="d-inline-block"><b>Yes</b></span></td>
                                        {/* <td className="col-home"><span className="d-inline-block w-50"><b>No</b></span><span className="d-inline-block w-50"><b>Yes</b></span></td> */}
                                    </>
                                    :
                                    <>
                                        <td className="col-visit">1</td>
                                        <td className="col-draw">x</td>
                                        <td className="col-home">2</td>
                                    </>
                                }

                                <td className="col-info"></td>
                            </tr> : <tr><td><span style={{ marginLeft: 5, fontSize: 14 }}>There is no active events.</span></td></tr>}

                            {game.map((event, i) => {
                                if (!!limit && limit > 0) {
                                    if (event.eventTypeId === this.props.gameCode) {
                                        count++
                                    }
                                    return <WebEvent isUpdate={this.props.isUpdate} history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.props.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.props.updateSubscribedMarkets(mkt) }} key={"we" + event.id} feedBooks={this.props.feedBooks} updateBook={(marketId, book) => { this.props.updateBook(marketId, book) }} socket={this.props.socket} isInplay={event.isInplay} display={event.eventTypeId === this.props.gameCode && count < limit + 1 ? "block" : "none"} index={count - 1} event={event} gameCode={this.props.gameCode} toggleMultiMarket={(marketId) => { this.props.toggleMultiMarket(marketId) }} pinnedEvents={this.props.pinnedEvents}/>
                                } else {
                                    return <WebEvent isUpdate={this.props.isUpdate} history={this.props.history} key={"we" + event.id} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.props.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.props.updateSubscribedMarkets(mkt) }} feedBooks={this.props.feedBooks} updateBook={(marketId, book) => { this.props.updateBook(marketId, book) }} socket={this.props.socket} isInplay={event.isInplay} display={event.eventTypeId === this.props.gameCode ? "block" : "none"} index={i} event={event} gameCode={this.props.gameCode} toggleMultiMarket={(marketId) => { this.props.toggleMultiMarket(marketId) }} pinnedEvents={this.props.pinnedEvents}/>
                                }
                            })}

                            {!!curGameLength && !!limit && curGameLength > limit && <tr>
                                <td colSpan="5">
                                    <a onClick={() => { window.location.href = this.props.gameCode === "300" ? "/binary" : "/game/" + this.props.gameCode }} className="viewmore" style={{ "cursor": "pointer" }} title="view more">View More...</a>
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>}
                {/* Mobile View */}
                {this.state.width <= 767 && <div className="game-wrap col3 mobile-view">

                    {curGameLength === 0 && <span style={{ marginLeft: 5, fontSize: 14 }}>There is no active events.</span>}
                    {game.map((event, i) => {
                        if (!!limit && limit > 0) {
                            if (event.eventTypeId === this.props.gameCode) {
                                count++
                            }
                            return (event.eventTypeId === this.props.gameCode && count < limit + 1 && <MobEvent isUpdate={this.props.isUpdate} history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.props.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.props.updateSubscribedMarkets(mkt) }} key={"me" + event.id} feedBooks={this.props.feedBooks} updateBook={(marketId, book) => { this.props.updateBook(marketId, book) }} socket={this.props.socket} isInplay={event.isInplay} display={event.eventTypeId === this.props.gameCode && count < limit + 1 ? "block" : "none"} index={i} event={event} gameCode={this.props.gameCode} toggleMultiMarket={(marketId) => { this.props.toggleMultiMarket(marketId) }} pinnedEvents={this.props.pinnedEvents}/>)
                        } else {
                            return <MobEvent isUpdate={this.props.isUpdate} history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.props.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.props.updateSubscribedMarkets(mkt) }} key={"me" + event.id} feedBooks={this.props.feedBooks} updateBook={(marketId, book) => { this.props.updateBook(marketId, book) }} socket={this.props.socket} isInplay={event.isInplay} display={event.eventTypeId === this.props.gameCode ? "block" : "none"} index={i} event={event} gameCode={this.props.gameCode} toggleMultiMarket={(marketId) => { this.props.toggleMultiMarket(marketId) }} pinnedEvents={this.props.pinnedEvents} />
                        }
                    })}
                    {!!curGameLength && !!limit && curGameLength > limit && <div className="h23" onClick={() => { window.location.href = this.props.gameCode === "300" ? "/binary" : "/game/" + this.props.gameCode }}><a className="viewmore" style={{ "cursor": "pointer" }} title="view more">View More...</a></div>}
                </div>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        homeData: state
    };
}
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(GameBox);
